import { isRight } from "fp-ts/lib/Either";
import { DateTime } from "luxon";
import { DataType } from "./dataType";
import { ISODatetime } from "../../../../../../schema/period";

/**
 * @description
 * Convert series configuration & subdataset value to highcharts axis value.
 */
export const convertToAxisValue = (
  type: DataType | null | undefined,
  value: string | number | null | undefined,
) =>
  type === DataType.Temporal && typeof value === "string" && isRight(ISODatetime.decode(value))
    ? DateTime.fromISO(value).toMillis()
    : type === DataType.Quantitative && typeof value === "number"
      ? value
      : undefined;
